{
  "version": 1,
  "asset_id": "e6e225dc-ee3f-4b45-b89e-a7bc8c861f4c",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/e6e225dc-ee3f-4b45-b89e-a7bc8c861f4c/bahcesehir-hizli-elektrikci-7-24-dukkan-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/e6e225dc-ee3f-4b45-b89e-a7bc8c861f4c/bahcesehir-hizli-elektrikci-7-24-dukkan-2.jpg",
  "original_filename": "bahcesehir-hizli-elektrikci-7-24-dukkan-2.jpg",
  "size": 547783,
  "content_type": "image/jpeg",
  "created_at": "2026-09-11T16:18:40Z"
}
